import { Controller } from "@hotwired/stimulus"

// Prevents double-clicks on buttons/links, especially those with confirm dialogs.
// Re-enables the element if the user cancels the confirm dialog.
//
// Usage:
//   <button data-controller="disable-on-click"
//           data-action="click->disable-on-click#disable">
//
// Or with turbo confirm:
//   <%= link_to path,
//       data: {
//         controller: 'disable-on-click',
//         action: 'click->disable-on-click#disable',
//         turbo_method: :patch,
//         turbo_confirm: t('confirm_message')
//       } %>
//
export default class extends Controller {
  disable(event) {
    if (this.element.dataset.disabled === "true") {
      event.preventDefault()
      event.stopPropagation()
      return
    }

    this.element.dataset.disabled = "true"
    this.element.classList.add("btn-disabled")
    this.element.setAttribute("aria-disabled", "true")
    if ("disabled" in this.element) this.element.disabled = true

    this.cancelTimer = setTimeout(() => this.#enable(), 300)
    this.fallbackTimer = setTimeout(() => this.#enable(), 15000)

    document.addEventListener("turbo:before-fetch-request", () => {
      clearTimeout(this.cancelTimer)
    }, { once: true })
  }

  #enable() {
    this.element.dataset.disabled = "false"
    this.element.classList.remove("btn-disabled")
    this.element.removeAttribute("aria-disabled")
    if ("disabled" in this.element) this.element.disabled = false
    clearTimeout(this.fallbackTimer)
    clearTimeout(this.cancelTimer)
  }

  disconnect() {
    clearTimeout(this.fallbackTimer)
    clearTimeout(this.cancelTimer)
  }
}
